export class StaffGroupForm {
    id = null;
    name = null;
    code = null;
}